import { useState } from "react";
import Sidebar from "../components/Layout/Sidebar";
import Topbar from "../components/Layout/Topbar";
import { Outlet } from 'react-router-dom';
/* import i18n from 'i18next'; */
import { FormatProvider } from "../components/FormatContext";

const MainLayout = () => {

  const userSettings = {
    locale: "en-US", // 或 "de-DE" 等
    // …其他设置
  };
  //i18n.changeLanguage(userSettings.locale);

  const [collapsed, setCollapsed] = useState(false);
  const [fixCollapsed, setFixCollapsed] = useState(false);
  const [activeKey, setActiveKey] = useState(false);

  // 切换 Sidebar 状态
  const toggleSidebar = () => {
    setCollapsed(!collapsed);
    setFixCollapsed(!fixCollapsed);
    setActiveKey(!activeKey);
  };

  return (
    <FormatProvider>
      <div className="layout">
        {/* Topbar 占据最上方 */}
        <Topbar toggleSidebar={toggleSidebar} collapsed={collapsed} />

        <div className="main-container h-100">
          {/* 左侧 Sidebar */}
          <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} fixCollapsed={fixCollapsed} activeKey={activeKey} setActiveKey={setActiveKey} />

          {/* 右侧内容区域，保持自适应宽度 */}
          <div className={`main-content px-1 h-100 px-sm-2 ${collapsed ? "collapsed" : ""}`}>
            <Outlet />
          </div>
        </div>
      </div>
    </FormatProvider>
  );
};

export default MainLayout;
